<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add media</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New media by <span class="secondary--text">{{ set.item }}</span> set
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row class="subtitle-2 secondary--text text-left my-2">
                            I. Media costs:
                        </v-row>
                        <v-row>
                            <!--cost-->                            
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="SMM cost" persistent-hint
                                    v-model.number="smm_cost" name="smm_cost" type="text" :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="content ads cost"
                                    v-model.number="content_ads_cost" name="content_ads_cost" type="text"
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="bloggers & influencers cost"
                                    v-model.number="bloggers_influencers_cost" name="bloggers_influencers_cost"
                                    type="text" :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="banner ads cost"
                                    v-model.number="banner_ads_cost" name="banner_ads_cost"
                                    type="text" :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="postal mail cost"
                                    v-model.number="postal_cost" name="postal" type="text" :rules="[rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="outdoor advertising cost"
                                    v-model.number="outdoor_advertising_cost" name="outdoor_advertising_cost"
                                    type="text" :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="autoradio podcasts cost"
                                    v-model.number="autoradio_podcasts_cost" name="autoradio_podcasts_cost" type="text"
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="TV cost" v-model.number="tv_cost"
                                    name="tv_cost" type="text" :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <!--coverage-->
                        <v-row class="subtitle-2 secondary--text text-left my-2">
                            II. Media coverage:
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="SMM coverage" persistent-hint 
                                    v-model.number="smm_coverage"
                                    name="smm_coverage" type="text" 
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="content ads coverage" 
                                    v-model.number="content_ads_coverage"
                                    name="content_ads_coverage" type="text" 
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="bloggers & influencers coverage"
                                    v-model.number="bloggers_influencers_coverage" 
                                    name="bloggers_influencers_coverage" type="text"
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="banner ads coverage"
                                    v-model.number="banner_ads_coverage" 
                                    name="banner_ads_coverage" type="text"
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="postal mail coverage" 
                                    v-model.number="postal_coverage"
                                    name="postal_coverage" type="text" 
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="outdoor advertising coverage"
                                    v-model.number="outdoor_advertising_coverage" 
                                    name="outdoor_advertising_coverage" type="text"
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="autoradio podcasts coverage"
                                    v-model.number="autoradio_podcasts_coverage" 
                                    name="autoradio_podcasts_coverage" 
                                    type="text"
                                    :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" label="TV coverage" 
                                    v-model.number="tv_coverage" name="tv_coverage"
                                    type="text" :rules="[rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-pre-wrap subtitle-2">
                    {{ message }}
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="addMedia">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AddMedia',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },
            //props
            smm_cost: 0,
            content_ads_cost: 0,
            bloggers_influencers_cost: 0,
            banner_ads_cost: 0,
            postal_cost: 0,
            outdoor_advertising_cost: 0,
            autoradio_podcasts_cost: 0,
            tv_cost: 0,
            smm_coverage: 0,
            content_ads_coverage: 0,
            bloggers_influencers_coverage: 0,
            banner_ads_coverage: 0,
            postal_coverage: 0,
            outdoor_advertising_coverage: 0,
            autoradio_podcasts_coverage: 0,
            tv_coverage: 0,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        
    },
    methods: {
        onceMore() {
            this.error = ''
            this.message = '';
        },
        async addMedia() {

            if (this.$refs.form.validate()) {
                
                const media = {
                    gameId: this.set.value,
                    round: Number(this.round),
                    smm_cost: this.smm_cost,
                    content_ads_cost: this.content_ads_cost,
                    bloggers_influencers_cost: this.bloggers_influencers_cost,
                    banner_ads_cost: this.banner_ads_cost,
                    postal_cost: this.postal_cost,
                    outdoor_advertising_cost: this.outdoor_advertising_cost,
                    autoradio_podcasts_cost: this.autoradio_podcasts_cost,
                    tv_cost: this.tv_cost,
                    smm_coverage: this.smm_coverage,
                    content_ads_coverage: this.content_ads_coverage,
                    bloggers_influencers_coverage: this.bloggers_influencers_coverage,
                    banner_ads_coverage: this.banner_ads_coverage,
                    postal_coverage: this.postal_coverage,
                    outdoor_advertising_coverage: this.outdoor_advertising_coverage,
                    autoradio_podcasts_coverage: this.autoradio_podcasts_coverage,
                    tv_coverage: this.tv_coverage,
                }
                /*console.log(media);*/
                try {
                    //add resource
                    await this.$store.dispatch('addMedia', media)
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `${error.message}`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.$refs.form.reset();
        }
    },
}
</script>